/* Live Skio rules for the active box. No copied prices, limits, tiers or plan IDs. */
((scope) => {
  if (typeof module === 'undefined' && scope.MettaV2Skio) return;
  const id = value => String(value ?? '').split('/').pop();
  const numeric = value => /^\d+$/.test(id(value));
  function normalize(response, expected) {
    const box = response?.ok === true && response.DynamicBox;
    if (!box || !expected?.id || box.boxId !== expected.id || !numeric(expected.parentProductId)
      || box.currencyCode !== expected.currency || !Array.isArray(box.selectableProductVariants)) throw new Error('box_configuration');
    // Unrestricted price-based boxes only. Skio's price model decides the spend base:
    // "One-time" = price_before_selling_plan, "Subscription" = price_after_selling_plan (what the customer pays).
    if (box.fixedDiscountTier != null || box.sizeRange !== null || !['price_before_selling_plan', 'price_after_selling_plan'].includes(box.priceRange?.discountBase)
      || Number(box.priceRange.min) !== 0 || Number(box.priceRange.max) < 999999) throw new Error('box_limits');
    const tiers = Object.entries(box.percentDiscountTier || {});
    if (tiers.length !== 1 || !Number.isFinite(Number(tiers[0][0])) || Number(tiers[0][0]) <= 0
      || !Number.isFinite(Number(tiers[0][1])) || Number(tiers[0][1]) < 0 || Number(tiers[0][1]) > 100) throw new Error('box_tiers');
    const variantIds = box.selectableProductVariants.flatMap(p => (p.productVariants || []).map(v => id(v.platformId))).filter(numeric);
    // Skio's own position decides the default plan (4 weeks); the object's key order does not (it lists 8 weeks first).
    const sellingPlanGroup = Object.entries(box.sellingPlanGroup || {}).map(([gid, plan], index) => ({ ...plan, gid, position: Number.isFinite(Number(plan.position)) ? Number(plan.position) : index }))
      .filter(p => numeric(p.gid) && String(p.interval).toUpperCase() === 'WEEK' && Number.isInteger(Number(p.intervalCount)) && Number(p.intervalCount) > 0);
    if (!variantIds.length || !sellingPlanGroup.length) throw new Error('box_empty');
    const threshold = Math.round(Number(tiers[0][0]) * 100);
    if (!Number.isSafeInteger(threshold)) throw new Error('box_tiers');
    return { ...box, sellingPlanGroup, variantIds, oneBox: true,
      commerce: { currency: box.currencyCode, threshold, percent: Number(tiers[0][1]), discountBase: box.priceRange.discountBase, boxId: box.boxId } };
  }
  const pending = new Map();
  async function load(expected, { fresh = false } = {}) {
    const key = `${expected.id}|${expected.parentProductId}|${expected.currency}`;
    const cached = pending.get(key);
    if (!fresh && cached && Date.now() - cached.time < 30000) return cached.value;
    const value = (async () => {
      const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productPlatformId: String(expected.parentProductId) }), signal: AbortSignal.timeout(10000)
      });
      if (!response.ok) throw new Error('box_request');
      const raw = await response.json();
      return { config: normalize(raw, expected), raw };
    })();
    pending.set(key, { time: Date.now(), value });
    try { return await value; } catch (error) { pending.delete(key); throw error; }
  }
  const api = { normalize, load };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.MettaV2Skio = api;
})(typeof window === 'undefined' ? globalThis : window);
